export default __webpack_public_path__ + "static/communting-197ff432af5d42951d160d51e833776a.jpeg";